import { LOAD_USECASE_BY_PLANTS, LOAD_USECASE_BY_PLANTS_ERROR, LOAD_USECASE_BY_PLANTS_SUCCESS } from "../Types/usecaseByPlants.contsnts";

const INITIAL_STATE = {
    loading: false,
    usecasesByPlants: {},
    error: null,
}

export const usecasesByPlantsReducer = (state = INITIAL_STATE, action: any) => {
    switch (action.type) {
        case LOAD_USECASE_BY_PLANTS:
            return { ...state, loading: true, usecasesByPlants: {} };
        case LOAD_USECASE_BY_PLANTS_SUCCESS:
            return {
                ...state,
                loading: false,
                usecasesByPlants: action.payload,
            };
        case LOAD_USECASE_BY_PLANTS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}